var render, staticRenderFns
import script from "./TrainingWatchlistButton.vue?vue&type=script&lang=js"
export * from "./TrainingWatchlistButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec082a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ec082a')) {
      api.createRecord('07ec082a', component.options)
    } else {
      api.reload('07ec082a', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/TrainingWatchlistButton.vue"
export default component.exports